module.exports = __webpack_public_path__ + "img/bg (3).9b70263a.jpg";